export const WM_ENVIRONMENT = 'production' // production
export const PASSWORD_LENGTH = 8;
// export const TOKEN_NAME = WM_ENVIRONMENT === 'development' ? 'dev_wmtoken' : 'wmtoken';
export const TOKEN_NAME = WM_ENVIRONMENT === 'production' ? 'wmtoken' : 'dev_wmtoken';
export const IDENTITY = 'wmhandler';
export const MAIN_URL = WM_ENVIRONMENT === 'production' ? 'https://spiralbound.in/' : 'https://test.spiralbound.in/'
export const GOOGLE_CLIENT_ID = WM_ENVIRONMENT === 'production' ? '401710174050-603ll0vmb6jptifdnsbsg0n6s5uv56eu.apps.googleusercontent.com' : '401710174050-ihe1biak0odkf9gojllpu89hukd84qs6.apps.googleusercontent.com'
export const GOOGLE_RECAPTCHA_SITE_KEY = WM_ENVIRONMENT === 'production' ? '6LcblRosAAAAAIfWSzcEtknKRcl0uVE1p40e3lrN' : '6LeolBosAAAAAL41mlltZQQPL1Hwa0KIIe7Mh58N'
export const LOGO_PATH = "/spiral_bound_logo.jpeg";
export const PROJECT_NAME = "Spiral Bound";
export const TINY_MCE_API_KEY = "x0gexq6ide787iw78704q8hymufiou2lv0q07u3up7jj78i4";
